import { StudentInfo } from "../../student/studentSlice";
import { UserInfo } from "../../user/userSlice";

export interface SuggestionInfo {
  schoolId: string;
  faceId: string;
  imageId: string;
  suggestedFaceId: string;
  suggestedStudentId: string;
  suggestedUserId: string;
  l2: number;
  negative: number;
  cosine: number;
  l1: number;
}

export interface SuggestionDetailsInfo {
  suggestedFace: SuggestionInfo;
  student?: StudentInfo;
  user?: UserInfo;
}

export const suggestionDisplayname = (item: SuggestionDetailsInfo): string => {
  if(item.student) {
      return item.student.nickname || item.student.name;
  }
  if(item.user) {
      return item.user.name || item.user.email;
  }
  return "Não identificado";
};
